import React from 'react';
import SubCatList from './SubCatList';
import * as action from '../Actions';
import Service from '../../service/Service';
const service = new Service();
export default function ColoringMobileView({ eleRef }) {
    // eleRef.state.page = "ColoringCatDetails";
    // this.setState({page:'ColoringCatDetails'});
    
    return (
        <section className="coloring-mobile">
            <div className="all-catg" onClick={() => eleRef.opendropdown()}>
                <span className="M12_42 left">All Categories</span>
                {eleRef.state.showMsiteCat ?
                    <span data-icon-font="m" className="icon right"></span>
                    :
                    <span data-icon-font="j" className="icon right"></span>
                }
            </div>
            {eleRef.state.showMsiteCat &&
                <div className="all-catg-cnt">
                    <div className="search-text">
                        <input type="text" placeholder="Search your images here" id="searchMobile" onChange={event => action.updateSearchInput(event,eleRef)}></input>
                    </div>
                    <span className="search-ic" data-icon-font="'" onClick={() => action.SearchCategorydata(eleRef)}></span>
                    <ul className="all-catg-list">
                        {eleRef.state.categoryList && eleRef.state.categoryList.allCategories && eleRef.state.categoryList.allCategories[0] && eleRef.state.categoryList.allCategories[0].length > 0 && eleRef.state.categoryList.allCategories[0].map((list, index) =>
                            <li key={index} id={`catg_${list.categoryId}`} onClick={() => action.gotoCatDetail(service.replaceSymbols(list.categoryName),list.isSubCatData)}>
                                <span className="icon" data-icon-font="`"></span>
                                <span className="R12_42 cat-name">{list.categoryName}</span>
                            </li>
                        )}
                    </ul>
                </div>
            } 
            {eleRef.state.initialData && eleRef.state.initialData.map((catg, index) =>
                <div key={index} className="subcat-list-cnt">
                    {eleRef.state.page == "ColouringPageLanding" &&
                        <div className="cat-title">
                            <span className="M16_42 left" onClick={() => action.gotoCatDetail(service.replaceSymbols(catg.categoryName),catg.isSubCatData)}>{catg.categoryName}</span>
                            <span className="R12_link right" onClick={() => action.gotoCatDetail(service.replaceSymbols(catg.categoryName),catg.isSubCatData)}>View All</span>
                        </div>
                    }
                    {catg.subcategory &&
                        <SubCatList catg={catg} eleRef={eleRef} />
                    }
                </div>
            )}
        </section>
    )
}
